<div class="hdmui-subnav">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel" mat-stretch-tabs="false">
    @for (link of links; track link) {
      <a
        mat-tab-link
        [routerLink]="link.path"
        routerLinkActive
        #rla="routerLinkActive"
        [active]="rla.isActive"
        >
        {{ link.name | translate }}
      </a>
    }
  </nav>
</div>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
